import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import chat from "../../assets/images/chat.svg";
import { ChatActions } from "../../redux/slices/componentSlice/chat";
import "./index.scss";

const ChatButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toggleChat = () => {
    //   dispatch(ChatActions.toggleChat(true));
    navigate("/jia/chat");
  };
  return (
    <div className="parentDiv" onClick={() => toggleChat()}>
      <img src={chat} className="chatImg" />
    </div>
  );
};

export default ChatButton;
